"use client";

import { c as _c } from "react/compiler-runtime";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useIsVersionStale } from "@/hooks/useIsVersionStale";
import { type JSX } from "react";
const SHOW_NEW_VERSION_TOAST_PARAM = "showNewVersionToast";
const removeNewVersionToastOverrideFromCurrentPath = () => {
  const url = new URL(globalThis.location.href);
  url.searchParams.delete(SHOW_NEW_VERSION_TOAST_PARAM);
  globalThis.history.replaceState(globalThis.history.state, "", url);
};
const refreshWithoutToastOverride = () => {
  removeNewVersionToastOverrideFromCurrentPath();
  globalThis.location.reload();
};
const NewVersionToast = () => {
  const $ = _c(5);
  const isVersionStale = useIsVersionStale();
  const {
    isApp
  } = useDeviceInfo();
  if (!isVersionStale) {
    return null;
  }
  const t0 = `tw-fixed ${isApp ? "tw-bottom-24" : "tw-bottom-4"} tailwind-scope tw-pointer-events-none tw-left-4 tw-right-4 tw-z-[1000] sm:tw-bottom-7 sm:tw-left-auto sm:tw-right-7`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-whitespace-nowrap tw-text-[15px] tw-font-bold tw-leading-tight tw-text-[#f5f7f6] sm:tw-text-base">A new version is available</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-relative tw-z-10 tw-min-w-0 tw-pr-1">{t1}<div className="tw-mt-0.5 tw-flex tw-items-center tw-gap-1 tw-text-[13px] tw-font-semibold tw-leading-none tw-text-[#b9c0c4] sm:tw-text-sm"><span>Yes, again!</span><img src="/emojis/sgt_wink.webp" alt="" className="tw-size-4 tw-flex-shrink-0 tw-self-end tw-opacity-85 sm:tw-size-[18px]" /></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <button type="button" aria-label="Refresh page" title="Refresh page" onClick={refreshWithoutToastOverride} className="toast-shell tw-group tw-pointer-events-auto tw-relative tw-mx-auto tw-flex tw-w-full tw-animate-fadeIn tw-cursor-pointer tw-items-center tw-justify-between tw-gap-1 tw-overflow-hidden tw-rounded-[18px] tw-border-none tw-bg-[#15191b] tw-px-[18px] tw-py-2 tw-text-iron-50 tw-shadow-[0_0_0_1px_rgba(126,158,134,0.34),_0_2px_12px_rgba(0,0,0,0.36),_0_18px_40px_rgba(0,0,0,0.60),_0_0_34px_rgba(49,205,105,0.15),_inset_0_1px_0_rgba(255,255,255,0.07),_inset_0_-1px_0_rgba(49,205,105,0.08)] tw-backdrop-blur-xl tw-transition-[box-shadow,transform] tw-duration-200 tw-ease-out before:tw-pointer-events-none before:tw-absolute before:tw-inset-0 before:tw-origin-[82%_50%] before:tw-scale-95 before:tw-bg-[radial-gradient(circle_at_82%_50%,rgba(42,185,82,0.34),rgba(18,44,29,0.20)_32%,transparent_64%)] before:tw-opacity-0 before:tw-transition-[opacity,transform] before:tw-duration-200 before:tw-ease-out before:tw-content-[''] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-inset focus-visible:tw-ring-[#95ffad] active:tw-scale-[0.985] desktop-hover:hover:tw-shadow-[0_0_0_1px_rgba(66,168,84,0.50),_0_2px_12px_rgba(0,0,0,0.34),_0_18px_40px_rgba(0,0,0,0.56),_0_0_16px_rgba(49,205,105,0.12),_inset_0_1px_0_rgba(153,255,176,0.12),_inset_0_0_20px_rgba(35,126,61,0.12)] desktop-hover:hover:before:tw-scale-100 desktop-hover:hover:before:tw-opacity-100 sm:tw-ml-auto sm:tw-mr-0 sm:tw-w-[372px]">{t2}<span className="tw-relative tw-z-10 tw-flex tw-h-14 tw-w-fit tw-flex-shrink-0 tw-items-center tw-justify-center"><img src="/rocket-refresh.png" alt="" className="tw-relative tw-z-10 tw-h-12 tw-w-auto tw-flex-shrink-0 tw-text-[#dfffe8] tw-transition-all tw-duration-200 tw-ease-out group-active:tw-scale-[0.985] desktop-hover:group-hover:tw-brightness-150 desktop-hover:group-hover:tw-saturate-150" /></span></button>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t0) {
    t4 = <div className={t0}>{t3}</div>;
    $[3] = t0;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default NewVersionToast;